import React, { useEffect } from "react";
import { connect } from "react-redux";
import { CardControlsRestartButton } from "./card-controls-restart-button.component";
import { AuthPaymentContainer } from "../../authenticated-payments/misc/auth-payment-container.component";
import { getMailingAddress, submitCardRepalcement } from "../../../actions/cardControls.actions";
import Show from "../../../utils/show.component";

const VerifyMailingAddressComponent = (props) => {
  useEffect(() => {
    props.getMailingAddress();
  }, []);

  const advance = () => {
    props.submitCardRepalcement(
      props.cardInfo.agreeNbr,
      props.cardInfo.cardType,
      () => props.advanceToNextStep()
    );
  }

  return (
    <AuthPaymentContainer title={"Verify Your Address"}>
      <div className="mb-3">Your new card will be mailed to the address displayed below. If this address is incorrect, please give us a call at 888.267.7200, and we’ll update your address and order your new card.</div>
      {props.cardControls.mailingAddress && (
        <div className="alert primary" style={{textAlign: "center"}}>
          <div>{props.cardControls.mailingAddress.AddressLine1}</div>
          <Show condition={props.cardControls.mailingAddress.AddressLine2}>
            <div>{props.cardControls.mailingAddress.AddressLine2}</div>
          </Show>
          <div>{props.cardControls.mailingAddress.City}, {props.cardControls.mailingAddress.State} {props.cardControls.mailingAddress.ZipCode}</div>
        </div>
      )}
      <div className="row">
        <div className="col-12">
          <button
            className={"button full primary"}
            type="submit"
            onClick={() => advance()}
          >
            Continue
          </button>
        </div>
      </div>
      <CardControlsRestartButton backToCards={props.backToCards} buttonText="Cancel" />
    </AuthPaymentContainer>
  );
};

const mapDispatchToProps = {
  getMailingAddress,
  submitCardRepalcement
};

const VerifyMailingAddress = connect(null, mapDispatchToProps)(VerifyMailingAddressComponent);

export default VerifyMailingAddress;



// WEBPACK FOOTER //
// ./src/components/card-controls/misc/verify-mailing-address.component.js